import React from "react";
import "./Third.css";
import { Container } from "react-bootstrap";
// import team from "../../../../Asset/lifeatweb/15aug.jpg";
import { useNavigate } from "react-router-dom";

const Third = () => {
  const navigate = useNavigate();
  const hendleClick = () => {
    navigate("/ContactUs");
  };
  return (
    <>
      <section className="third-lifeat-section">
        <Container>
          <div className="top-text-lifeat-third">
            <h2>
              WORK-LIFE<span> BALANCE</span>
            </h2>
          </div>
          <div className="wo-work-life-row">
            <div className="col-xl-5 wo-work-life-col-1">
              <h3>
                A Mission-Driven Team That Make{" "}
                <strong className="text-skyblue"> Ideas Happen </strong>
              </h3>
              <p>
                With diverse backgrounds and talents, <b>Codeffian’s</b> unite
                to make the technology work for our clients. We are a group of
                individuals who challenge the status quo, among the fast
                learners, share good jokes, take a lot of pictures, do debates
                on popular opinions and a lot that adds joy. Sounds
                interesting?Join to enjoy good work humor and never get bored or
                micro-managed.{" "}
              </p>
              <button
                onClick={hendleClick}
                class="btn btn-primary"
                rel="noopener"
              >
                Join Our Team
              </button>
            </div>
            <div className="col-xl-7 wo-work-life-col-2">
              <div className="team-img">
                {/* <Image
                  src={team}
                  className="w-100"
                  alt="Description of the image"
                /> */}
              </div>
              <div className="team-absolute">
                <h2>Codeffian’s</h2>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
